<div class="innerContainer">
    <div class="provider-status-dashboard">
        <div class="font-weight-bold grpHeader">Payment Methods</div>
        <div class="divider"></div>
        <div class="payment-methods-dashboard container p-0 widgetBodyContainer">

            <div class="row headerRow-nb">
                <div class="col col-7">
                    <strong>Card Number</strong>
                </div>
                <div class="col col-5">
                    <strong>Expiration Date</strong>
                </div>
            </div>
            <div class="divider-3 darker"></div>
            <div class="row cardInfo" *ngFor="let method of paymentMethods | limitTo : 3">
                <div class="col col-2 cardIcon">
                    <img src="{{'assets/images/icon_images/' + method.cardType + '.png'}}" title="method.cardType" class="img-fluid" />
                </div>
                <div class="col col-5 cardLastDigits">
                    <span class="digits">x{{method.creditCardNumber}}</span>
                </div>
                <div class="col col-5 cardExpireDate">
                    <span class="{{method.cardExpired ? 'error' : ''}} outDated">Exp: {{method.ccShortDate}}</span>
                </div>
            </div>
            <div class="row" *ngIf="paymentMethods.length < 1">
                <div class="col col-12">
                    <i>No Payment Methods to Display</i>
                </div>
            </div>
        </div>
    </div>

    <div class="widgetLoader {{paymentMethodDoneProcessing ? 'hidethis' : ''}}"></div>
</div>